import React, { SVGProps } from "react";

export default function SupAlert(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.5035 9.802V7.546H9.51953V9.802L9.68753 12.958H10.3235L10.5035 9.802Z" fill="currentColor" />
      <path d="M10.7555 15.25V13.858H9.25553V15.25H10.7555Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13397 2.75C9.51888 2.08333 10.4811 2.08333 10.866 2.75L18.6603 16.25C19.0452 16.9167 18.564 17.75 17.7942 17.75H2.20577C1.43597 17.75 0.954845 16.9167 1.33975 16.25L9.13397 2.75ZM10 3.25L17.7942 16.75H2.20577L10 3.25Z"
        fill="currentColor"
      />
    </svg>
  );
}
